import {useMutation} from '../react-query';
import {useLegacyGrpcClientConfig} from './GrpcClientContext';
// eslint-disable-next-line no-restricted-imports
import {InferResponseType, MakeAllKeysRequired} from '../types';
import {convertAllNullPropertiesToUndefined} from './convertAllNullPropertiesToUndefined';
import {
  GrpcMutationConfig,
  GrpcRequestServiceMethod,
  useGenericGrpcRequestFn,
} from './useGenericGrpcRequest';
import {GenericGripsConfig, GripsDevice} from './useLegacyGrpcRequest';

/**
 * A convenience wrapper around `useMutation` to do GRPC mutations.
 * The GRPC `channel` will be read from context.
 * @param serviceMethod the GRPC service method to call
 * @param params the parameters for the specific GRPC function
 * @param config the config for useRequest react-query
 */
export function useLegacyGrpcRequestCallback<
  ServiceMethod extends GrpcRequestServiceMethod,
  ResponseType extends InferResponseType<
    ReturnType<Awaited<ReturnType<ServiceMethod>>>
  >,
  ParamsType extends MakeAllKeysRequired<
    Omit<
      Parameters<Awaited<ReturnType<ServiceMethod>>>[1],
      keyof GenericGripsConfig
    >
  >,
>(serviceMethod: ServiceMethod, config?: GrpcMutationConfig<ResponseType>) {
  const {shopId, childShopId, device} = useLegacyGrpcClientConfig();
  const genericConfig = {
    shopId,
    childShopId,
    device: device === 'mobile' ? GripsDevice.MOBILE_WEB : GripsDevice.DESKTOP,
  };

  const fetch = useGenericGrpcRequestFn(
    serviceMethod,
    {} as ParamsType,
    genericConfig,
  );

  const mutate = (params: ParamsType) =>
    fetch(convertAllNullPropertiesToUndefined<ParamsType>(params));

  return useMutation(mutate, config);
}
